var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "translate(.104 .188)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.277,
    cy: 24.565,
    fill: "#336DCF",
    opacity: 0.102,
    rx: 24.277,
    ry: 24.565
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4764CD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.517 29.026v-9.852c0-1.407-1.01-2.627-2.341-2.72-1.515-.142-2.846 1.078-2.846 2.626v9.946c0 1.641-1.882 2.158-1.331 4.878.321 1.595 1.56 2.909 3.121 3.19 2.525.516 4.82-1.454 4.82-4.034 0-2.252-1.423-2.486-1.423-4.034zm-4.269-9.946a1.68 1.68 0 0 1 1.836-1.689c.872.047 1.515.845 1.515 1.783v4.644h-3.351V19.08zm1.056 17.123c-1.194-.234-2.158-1.22-2.433-2.486-.46-2.346 1.377-2.627 1.377-4.691v-4.27h3.351v4.27c0 1.97 1.423 2.11 1.423 4.08 0 1.971-1.744 3.472-3.718 3.097zM21.887 14.67h-7.299c-1.193 0-2.02.939-2.02 1.97 0 1.033.78 2.018 2.02 2.018v14.59c0 2.064 1.653 3.706 3.627 3.706 1.974 0 3.626-1.69 3.626-3.706v-14.59c1.24 0 2.02-.938 2.02-1.97.046-1.08-.78-2.017-1.974-2.017zm-.918 18.578c0 1.548-1.24 2.767-2.708 2.767-1.47 0-2.709-1.266-2.709-2.767v-1.595h1.653c.275 0 .459-.188.459-.47 0-.28-.184-.469-.46-.469h-1.698v-1.782h1.699c.275 0 .459-.188.459-.47 0-.28-.184-.468-.46-.468h-1.698V26.21h1.699c.275 0 .459-.188.459-.47 0-.28-.184-.468-.46-.468h-1.698v-2.205h1.699c.275 0 .459-.188.459-.47 0-.28-.184-.468-.46-.468h-1.698v-3.472h5.463v14.59zm.964-15.528h-7.437a1.08 1.08 0 0 1-1.055-1.08c0-.609.505-1.031 1.055-1.031h7.437c.55 0 1.056.469 1.056 1.079s-.46 1.032-1.056 1.032z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EAF0FA",
    d: "M36.542 18.257l-3.505-6.02-3.492 6.02a4.336 4.336 0 0 0-.579 2.16c0 2.322 1.831 4.208 4.084 4.208 2.252 0 4.083-1.886 4.083-4.208-.012-.794-.217-1.539-.59-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4764CD",
    d: "M36.726 18.42L33.2 12.387l-3.513 6.033a4.333 4.333 0 0 0-.582 2.164c0 2.326 1.842 4.217 4.107 4.217s4.106-1.89 4.106-4.217a4.306 4.306 0 0 0-.593-2.164zm1.713 2.164c0 2.945-2.338 5.345-5.226 5.345-2.889 0-5.227-2.4-5.227-5.345 0-.97.257-1.9.736-2.735l3.513-6.033a1.116 1.116 0 0 1 1.93-.001l3.522 6.026c.48.797.737 1.738.752 2.743zm-6.928-2.383v.762h1.318v1.366h.742v-1.366h1.344V18.2h-1.331v-1.367h-.742v1.367H31.51zm.09 2.831v.721h3.223v-.72h-3.222z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/lab-test.2d845d1f639345157d9f6dbc10aaa367.svg";
export { ForwardRef as ReactComponent };